import { z } from "zod";

import { sectionSchema } from "./home/sectionSchema";

export const pagesSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string().optional().nullable(),
  slug: z.string().optional().nullable(),
  seo_title: z.string().optional().nullable(),
  seo_description: z.string().optional().nullable(),
  seo_image_url: z.string().optional().nullable(),
  is_indexable: z.boolean().optional().nullable(),
  languages: z.string().array().optional().nullable(),
  sections: sectionSchema.array(),
});

export type Pages = z.infer<typeof pagesSchema>;
